import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import EditOrderForm from './EditOrderForm';

interface ModalProps {
  editingOrderUid?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const EditOrderModal: React.FC<ModalProps> = ({
  editingOrderUid,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className='sd-font edit-order-modal'
      title={
        <div className='text-lg font-semibold text-sd-foreground'>
          {t('edit_order')}
        </div>
      }
      width={1000}
      centered
      footer={null}
      open={!!editingOrderUid}
      onOk={onClose}
      onCancel={onClose}
      destroyOnClose
      styles={{
        content: {
          borderRadius: '12px',
          padding: 0,
          overflow: 'hidden',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column' as const,
        },
        header: {
          padding: '16px 24px',
          marginBottom: 0,
          background: '#fff',
          borderBottom: '1px solid #e8e6e3',
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        body: {
          padding: 0,
          background: '#ffffff',
          overflow: 'hidden',
          flex: 1,
          display: 'flex',
          flexDirection: 'column' as const,
        },
      }}
    >
      {editingOrderUid && (
        <EditOrderForm
          onClose={onClose}
          editingOrderUid={editingOrderUid}
          onSuccess={onSuccess}
        />
      )}
    </Modal>
  );
};

export default EditOrderModal;
